import type {
  WhatsAppMappingType,
  WhatsAppMediaType,
} from "src/services/WhatsAppCampaignAPI";
import type {
  WhatsAppCampaignStepKey,
  WhatsAppTemplateStatusFilter,
} from "./WhatsAppCampaignTypes";

export const WHATSAPP_EDITOR_KEY = "campaignFlow.whatsappEditor";

export const WHATSAPP_CAMPAIGN_STEPS: { key: WhatsAppCampaignStepKey; titleKey: string }[] = [
  { key: "chooseTemplate", titleKey: `${WHATSAPP_EDITOR_KEY}.steps.chooseTemplate` },
  { key: "editor", titleKey: `${WHATSAPP_EDITOR_KEY}.steps.editor` },
];

export const META_TEMPLATES_URL = "https://business.facebook.com/wa/manage/message-templates/";

export const TEMPLATE_STATUS_FILTERS: WhatsAppTemplateStatusFilter[] = [
  "all",
  "approved",
  "pending",
  "rejected",
  "unavailable",
];

export const VARIABLE_MAPPING_TYPES: WhatsAppMappingType[] = ["column", "static", "date"];

export const TEMPLATE_PLACEHOLDER_PATTERN = /\{\{(\d+)\}\}/;

export const MEDIA_RULES: Record<WhatsAppMediaType, { accept: string[]; maxSizeMb: number }> = {
  image: { accept: ["image/jpeg", "image/png"], maxSizeMb: 5 },
  video: { accept: ["video/mp4", "video/3gpp"], maxSizeMb: 16 },
  document: { accept: ["application/pdf"], maxSizeMb: 100 },
};

export const BYTES_PER_MB = 1024 * 1024;

export const TEMPLATES_PAGE_SIZE = 6;
export const PREVIEW_DEBOUNCE_MS = 400;

export const MESSAGE_TIME_FORMAT = "h:mm A";
export const DATETIME_PARAMETER_FORMAT = "dddd, MMMM D [at] h:mm A";
export const DATETIME_VALUE_FORMAT = "YYYY-MM-DDTHH:mm:ss";

export const NO_LIST_NAMES: string[] = [];
